export default "__VITE_ASSET__a5e77f25__"